import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function (theme) { return ({
    root: {
        whiteSpace: 'inherit',
        fontSize: '14px',
        color: theme.palette.grey[900],
    },
}); };
export var FieldLabel = function (_a) {
    var htmlFor = _a.htmlFor, children = _a.children;
    var root = useEmotionStyles(styles).root;
    return (React.createElement(InputLabel, { htmlFor: htmlFor, className: root }, children));
};
export default FieldLabel;
